module.exports = __webpack_public_path__ + "img/logo-grande.3d730ba6.jpg";